var _toConsumableArray = require("/home/circleci/project/frontend/node_modules/@babel/runtime/helpers/toConsumableArray.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Split given tag selector into it's components.
 * Only element name, class names and ID names are supported.
 *
 * @param { string } selector Tag selector ("tag.class#id" etc).
 * @returns { { classes: string[], element: string, ids: string[] } }
 */
function splitSelector(selector) {
  function getParams(re, string) {
    var captures = [];
    var found;
    while ((found = re.exec(string)) !== null) {
      captures.push(found[1]);
    }
    return captures;
  }
  return {
    classes: getParams(/\.([\d\w-]*)/g, selector),
    element: /(^\w*)/g.exec(selector)[1],
    ids: getParams(/#([\d\w-]*)/g, selector)
  };
}

/**
 * Given a list of class and ID selectors (prefixed with '.' and '#'),
 * return them as separate lists of names without prefixes.
 *
 * @param { string[] } selectors Class and ID selectors (`[".class", "#id"]` etc).
 * @returns { { classes: string[], ids: string[] } }
 */
function splitClassesAndIds(selectors) {
  var classes = [];
  var ids = [];
  var _iterator = _createForOfIteratorHelper(selectors),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var selector = _step.value;
      if (selector.startsWith('.')) {
        classes.push(selector.substring(1));
      } else if (selector.startsWith('#')) {
        ids.push(selector.substring(1));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return {
    classes: classes,
    ids: ids
  };
}

/**
 * Make a recursive function that will only run to a given depth
 * and switches to an alternative function at that depth. \
 * No limitation if `n` is `undefined` (Just wraps `f` in that case).
 *
 * @param   { number | undefined } n   Allowed depth of recursion. `undefined` for no limitation.
 * @param   { Function }           f   Function that accepts recursive callback as the first argument.
 * @param   { Function }           [g] Function to run instead, when maximum depth was reached. Do nothing by default.
 * @returns { Function }
 */
function limitedDepthRecursive(n, f) {
  var g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return undefined;
  };
  if (n === undefined) {
    var f1 = function f1() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return f.apply(void 0, [f1].concat(args));
    };
    return f1;
  }
  if (n >= 0) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return f.apply(void 0, [limitedDepthRecursive(n - 1, f, g)].concat(args));
    };
  }
  return g;
}

/**
 * Convert a number into alphabetic sequence representation (Sequence without zeroes).
 *
 * For example: `a, ..., z, aa, ..., zz, aaa, ...`.
 *
 * @param   { number } num              Number to convert. Must be >= 1.
 * @param   { string } [baseChar = 'a'] Character for 1 in the sequence.
 * @param   { number } [base = 26]      Number of characters in the sequence.
 * @returns { string }
 */
function numberToLetterSequence(num) {
  var baseChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'a';
  var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 26;
  var digits = [];
  do {
    num -= 1;
    digits.push(num % base);
    num = num / base >> 0; // quick `floor`
  } while (num > 0);
  var baseCode = baseChar.charCodeAt(0);
  return digits.reverse().map(function (n) {
    return String.fromCharCode(baseCode + n);
  }).join('');
}
var I = ['I', 'X', 'C', 'M'];
var V = ['V', 'L', 'D'];

/**
 * Convert a number to it's Roman representation. No large numbers extension.
 *
 * @param   { number } num Number to convert. `0 < num <= 3999`.
 * @returns { string }
 */
function numberToRoman(num) {
  return _toConsumableArray(num + '').map(function (n) {
    return +n;
  }).reverse().map(function (v, i) {
    return v % 5 < 4 ? (v < 5 ? '' : V[i]) + I[i].repeat(v % 5) : I[i] + (v < 5 ? V[i] : I[i + 1]);
  }).reverse().join('');
}

/**
 * Return the same string or a substring with the given character occurences removed from each end if any.
 *
 * @param   { string } str  A string to trim.
 * @param   { string } char A character to be trimmed.
 * @returns { string }
 */
function trimCharacter(str, char) {
  var start = 0;
  var end = str.length;
  while (start < end && str[start] === char) {
    ++start;
  }
  while (end > start && str[end - 1] === char) {
    --end;
  }
  return start > 0 || end < str.length ? str.substring(start, end) : str;
}

/**
 * Get a nested property from an object.
 *
 * @param   { object }   obj  The object to query for the value.
 * @param   { string[] } path The path to the property.
 * @returns { any }
 */
function get(obj, path) {
  var _iterator2 = _createForOfIteratorHelper(path),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var key = _step2.value;
      if (!obj) {
        return undefined;
      }
      obj = obj[key];
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return obj;
}

/**
 * Set a nested property of an object.
 *
 * @param { object }   obj   The object to modify.
 * @param { string[] } path  The path to the property.
 * @param { any }      value The value to set.
 */
function set(obj, path, value) {
  var valueKey = path.pop();
  var _iterator3 = _createForOfIteratorHelper(path),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var key = _step3.value;
      var nested = obj[key];
      if (!nested) {
        nested = {};
        obj[key] = nested;
      }
      obj = nested;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  obj[valueKey] = value;
}
module.exports = {
  get: get,
  limitedDepthRecursive: limitedDepthRecursive,
  numberToLetterSequence: numberToLetterSequence,
  numberToRoman: numberToRoman,
  set: set,
  splitClassesAndIds: splitClassesAndIds,
  splitSelector: splitSelector,
  trimCharacter: trimCharacter
};